import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { setNonce } from "get-nonce";
import App from "./App";
import { getCspNonce } from "./lib/csp-nonce";
import { installChunkReloadHandler } from "./lib/chunk-reload";
import "./index.css";

// Recover from a stale lazy-chunk load after a redeploy (a tab on the OLD build
// that navigates to a renamed route chunk — e.g. the post-sign-in redirect to a
// lazy route). Installed before React renders so the very first navigation is
// covered. See chunk-reload.ts for the full rationale (the black-screen path the
// app-wide ErrorBoundary in App.tsx, #1837, cannot fully recover on its own).
installChunkReloadHandler();

// Wire the per-request CSP style-src nonce (#1499) into react-remove-scroll /
// react-style-singleton BEFORE any component (Radix Dialog/Popover) mounts,
// so their scroll-lock <style> injection carries it automatically. No-op in
// dev (getCspNonce() returns undefined; dev's CSP keeps 'unsafe-inline').
const cspNonce = getCspNonce();
if (cspNonce) setNonce(cspNonce);

const container = document.getElementById("root");
if (!container) throw new Error("[main] Root element #root not found in DOM");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
